import { ReactElement } from 'react'
import { Clear, Search } from '@mui/icons-material'
import { IconButton, InputAdornment, TextField, useTheme } from '@mui/material'

interface ElementListSearchBarProps {
  value: string
  onChange: (next: string) => void
}

/** Text search for the element list — matches label / cross-section / assembly. */
const ElementListSearchBar = ({ value, onChange }: ElementListSearchBarProps): ReactElement => {
  const theme = useTheme()

  return (
    <TextField
      size="small"
      value={value}
      onChange={event => onChange(event.target.value)}
      placeholder="Suchen…"
      fullWidth
      data-cy="element-list-search"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search sx={{ fontSize: 16, color: theme.palette.text.secondary }} />
          </InputAdornment>
        ),
        endAdornment: value ? (
          <InputAdornment position="end">
            <IconButton
              size="small"
              edge="end"
              aria-label="Suche zurücksetzen"
              onClick={() => onChange('')}
            >
              <Clear sx={{ fontSize: 16 }} />
            </IconButton>
          </InputAdornment>
        ) : undefined,
        sx: { fontSize: 13, height: 32 },
      }}
    />
  )
}

export default ElementListSearchBar
